import React, { forwardRef, useImperativeHandle, useState } from 'react';
import CustomInspectionTemplateList, {
  CustomInspectionTemplateListProps,
} from '../CustomInspectionTemplateList';
import { useMemoizedFn } from 'ahooks';
import { Modal } from '@bedrock/components';
import withFunctionCall from '#utils/withFunctionCall';

export interface CustomInspectionTemplateSelectPropsType {
  defaultSelectedRowKeys?: number[]; // 默认选中行
  visible?: boolean;
  onOk?: (selectedRowKeys: number[]) => void;
  onCancel?: () => void;
  defaultFilters?: CustomInspectionTemplateListProps['defaultFilters']; // 默认筛选条件
  fixedFilters?: CustomInspectionTemplateListProps['fixedFilters']; // 固定筛选条件
}

const CustomInspectionTemplateSelect = (props: CustomInspectionTemplateSelectPropsType) => {
  const { onOk, onCancel, visible } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);

  return (
    <Modal
      title="引用模板"
      width={960}
      visible={visible}
      okText="确定"
      cancelText="取消"
      okButtonProps={{ disabled: !selectedRowKeys?.length }}
      onOk={() => {
        onOk?.(selectedRowKeys);
        onCancel?.();
      }}
      onCancel={onCancel}
      onClose={onCancel}
      destroyOnClose={true}
    >
      <CustomInspectionTemplateList
        mode="Select"
        selectedRowKeys={selectedRowKeys}
        onSelectRowChange={setSelectedRowKeys}
        defaultFilters={props.defaultFilters}
        fixedFilters={props.fixedFilters}
      />
    </Modal>
  );
};

export default withFunctionCall(CustomInspectionTemplateSelect);
